<template>
	<div class="company_table">
		<div class="table">
			<el-table ref="multipleTable" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" label="级别" width="70" prop="rank_name">
				</el-table-column>
				<el-table-column align="center" prop="agent_name" label="名称" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="address" label="详细地址" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="stores_tel" label="联系电话" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="up_agent_name" label="直属上级" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="add_time" label="录入时间"  show-overflow-tooltip>
					<template slot-scope="scope">{{ scope.row.add_time | timeStamp }}</template>
				</el-table-column>
				<el-table-column align="center" prop="is_confirm" label="是否开启" width="90" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-switch v-model="scope.row.is_confirm" @change="switchChange(scope.row)" active-value="1" inactive-value="0" active-color="#1E69FF" inactive-color="#B5CBF9">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作" width="240" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="openDetail(scope.$index, scope.row)">查看</el-button>
						<el-button size="mini"
							style="background: #FF9D1F;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="handleEdit(scope.$index, scope.row)">编辑
							</el-button>
						<i class="el-icon-delete" style="margin-left: 10px;cursor: pointer;font-size: 1.3rem;"
							@click="handleDelete(scope.$index, scope.row)"></i>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<footer class="d-flex j-sb a-center">
			<div>
				<el-button round size="mini" @click="agentListExport">导出</el-button>
				<el-button round size="mini" @click="openAgentConfirm">批量开启</el-button>
				<el-button round size="mini" @click="closeAgentConfirm">批量关闭</el-button>
				<el-button round size="mini" @click="delAgentConfirm">批量删除</el-button>
			</div>			
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :page-size="10" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
	</div>

</template>

<script>
	import Blob from 'blob';
	import axios from 'axios'
	import qs from 'qs';
	export default {
		data(){
			return {
				currentPage: 1, //初始页
				pageSize: 10, //    每页的数据
				tableData: [],
				multipleSelection: [],
				keyword : '',
				evPage : 1,
				evSize : 0,
				page_count : 0,
				total_records : 0,
				agentId :[],
				agent_id : ''
			}
		},
		methods:{
			getCompanylist(){
				let param = {
					act : 'sub_agent_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					data_type : 'company',
					page : this.currentPage,
					size : this.pageSize
				}
				this.$api.company_list(param).then((res)=>{
					if(res.code == 0){
						this.tableData = res.data
						this.evSize = parseInt(res.size) 
						this.evPage = parseInt(res.page)
						this.page_count = parseInt(res.page_count)
						this.total_records = parseInt(res.total_records)
						localStorage.setItem('company_list', JSON.stringify(res.data))
					}
				})
			},
			// 导出列表
			agentListExport(){
				let param = {
					act : 'sub_agent_list_export',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					data_type : 'company'
				}
				this.$api.agentListExport(param).then(res => {
					let blob = new Blob([res], { type: 'application/vnd.ms-excel' }); //type为所需要下载的文件格式，xls文件			 
					//浏览器兼容，Google和火狐支持a标签的download，IE不支持
					if (window.navigator && window.navigator.msSaveBlob) {
						//IE浏览器、微软浏览器
						/* 经过测试，微软浏览器Microsoft Edge下载文件时必须要重命名文件才可以打开，
						  IE可不重命名，以防万一，所以都写上比较好 */
						window.navigator.msSaveBlob(blob, '下级分公司列表.xls');
					 } else {
						//其他浏览器
						let execlName = "下级分公司列表";
						let link = document.createElement('a'); // 创建a标签
						link.style.display = 'none';
						link.download = `${execlName}.xls`;
						let objectUrl = URL.createObjectURL(blob);
						link.href = objectUrl;
						link.click();
						URL.revokeObjectURL(objectUrl);
					  }
					})
					.catch(err => {
					  this.$message.error(err.message);
				})
			},
			// 单独开启
			switchChange(item){
				let num = parseInt(item.is_confirm)
				if(num == 0){
					let param = {
						act : 'operation_agent_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						agent_ids : item.agent_id,
						ctrl : 'close'
					}
					this.$api.company_list(param).then((res) => {
						if(res.code == 0){
							this.$message.success('关闭成功');
						}else{
							this.$message.error(res.msg);
						}
					}).catch((err) => {
						this.$message.error(err);
					})
				}else {
					let param = {
						act : 'operation_agent_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						agent_ids : item.agent_id,
						ctrl : 'open'
					}
					this.$api.company_list(param).then((res) => {
						if(res.code == 0){
							this.$message.success('开启成功');
						}else{
							this.$message.error(res.msg);
						}
					}).catch((err) => {
						this.$message.error(err);
					})
				}
			},
			// 批量开启
			openAgentConfirm(){
				if(this.agentId.length == 0){
					this.$message({
						type: 'warning',
						message: '请至少选择一个公司！'
					});
				}else{
					let param = {
						act : 'operation_agent_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						agent_ids : this.agentId.join(','),
						ctrl : 'open'
					}
					this.$api.company_list(param).then((res) => {
						if(res.code == 0){
							this.$message.success(res.msg);
							this.multipleSelection.forEach((v) => {
								v.is_confirm = 1
							})
						}else{
							this.$message.error(res.msg);
						}
					}).catch((err) => {
						this.$message.error(err);
					})
				}
			},
			// 批量关闭
			closeAgentConfirm(){
				if(this.agentId.length == 0){
					this.$message({
						type: 'warning',
						message: '请至少选择一个公司！'
					});
				}else{
					let param = {
						act : 'operation_agent_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						agent_ids : this.agentId.join(','),
						ctrl : 'close'
					}
					this.$api.company_list(param).then((res) => {
						if(res.code == 0){
							this.$message.success(res.msg);
							this.multipleSelection.forEach((v) => {
								v.is_confirm = 0
							})
						}else{
							this.$message.error(res.msg);
						}
					})
				}
			},
			// 批量删除
			delAgentConfirm(){
				if(this.agentId.length == 0){
					this.$message({
						type: 'warning',
						message: '请至少选择一个公司！'
					});
				}else{
					this.$msgbox.confirm('是否确认此操作?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let param = {
							act : 'operation_agent_list',
							token: localStorage.getItem('token'),
							user_id: localStorage.getItem('user_id'),
							agent_ids : this.agentId.join(','),
							ctrl : 'del'
						}
						this.$api.company_list(param).then((res) => {
							if(res.code == 0){
								this.$message.success(res.msg);
								this.getCompanylist()
							}else{
								this.$message.error(res.msg);
							}
						}).catch((err) => {
							this.$message.error(err);
						})
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});  
					})					
				}
			},
			openDetail(index, row) {
				this.$router.push({
					name: 'company_detail',
					params: {
						id: row.agent_id
					}
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
				let agent = []
				this.multipleSelection.forEach((item) => {
					agent.push(item.agent_id)
				})
				this.agentId = agent
			},
			handleEdit(index, row) {
				this.$router.push({
					name: 'more_detail',
					params: {
						id: row.agent_id
					}
				})
			},
			// 单独删除
			handleDelete(index, row) {
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let param = {
						act : 'operation_agent_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						agent_ids : row.agent_id,
						ctrl : 'del'
					}
					this.$api.company_list(param).then((res) => {
						if(res.code == 0){
							this.$message.success(res.msg);
							this.tableData.splice(index, 1)
						}else{
							this.$message.error(res.msg);
						}
					}).catch((err) => {
						this.$message.error(err);
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});  
				})				
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getData()
			},
		},
		filters:{
			timeStamp: function(value) {
				if (!value) return '';
				var time = new Date(value * 1000);
				 function timeAdd0(str) {
					if (str < 10) {
					  str = '0' + str;
					}
					return str
				  }
				var y = time.getFullYear();
				var m = time.getMonth() + 1;
				var d = time.getDate();
				var h = time.getHours();
				var mm = time.getMinutes();
				var s = time.getSeconds();
				return y + '-' + timeAdd0(m) + '-' + timeAdd0(d) + ' ' + timeAdd0(h) + ':' + timeAdd0(mm) + ':' + timeAdd0(s);
			},
		},
		mounted() {
			this.agent_id = this.$route.params.id
			this.getCompanylist()
		}
	}
</script>

<style lang="scss" scoped>
	.company_table {
		.table {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}

		footer {
			width: 100%;
			height: 3.85rem;
			background: #FFFFFF;
			margin-top: 1.44rem;
			border-radius: 6px;
			padding: 0 1rem;
			box-sizing: border-box;
		}
	}
</style>
